import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import Page from '../../components/Page';
import {
    Grid,
    Typography,
    Card,
    CardHeader,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import Youtube from 'react-youtube';
import { useTutorialVideos, useTutorialCategories } from '../../hooks/useAppResources';

const PUBLIC_ROLE = "No Role/ Public";

const TutorialVideos = ({ isPublic = false }) => {
    ///// Currently vids either require a youtube Id or a embed version of a youtube link to function /////
    const { data: vids = [] } = useTutorialVideos();
    const userRole = useSelector((state) => state.CompanyReducer.userRole);
    const { data: vidCats = [] } = useTutorialCategories();

    const roleFilter = isPublic ? PUBLIC_ROLE : userRole?.name;

    const [expanded, setExpanded] = React.useState();
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded && panel);
    };
    const [vidsToShow, setVidsToShow] = React.useState([]);
    const [catsToShow, setCatsToShow] = React.useState([]);

    function initTutorialDisplay() {
        // Build fresh arrays each run so we don't accumulate when effect re-runs (e.g. on revisit)
        const newVidsToShow = [];
        const catsWithVideos = (vidCats || []).map((c) => ({
            id: c.id,
            videoCategoryName: c.videoCategoryName,
            videoCategoryOrder: c.videoCategoryOrder,
            hasVideos: false,
        }));

        function setVidData(item) {
            let foundRoles = JSON.parse(item?.vidRoles || '[]');
            for (let e = 0; e < catsWithVideos?.length; e++) {
                if (catsWithVideos[e]?.id == item?.vidCategory) {
                    let foundCatName = catsWithVideos[e]?.videoCategoryName;
                    let foundCatOrder = catsWithVideos[e]?.videoCategoryOrder;
                    for (let i = 0; i < foundRoles?.length; i++) {
                        if (foundRoles[i] == roleFilter) {
                            catsWithVideos[e] = {
                                ...catsWithVideos[e],
                                hasVideos: true,
                            };
                            newVidsToShow.push({
                                id: item.id,
                                vidUrl: item.vidUrl,
                                vidCategory: item.vidCategory,
                                vidDescription: item.vidDescription,
                                vidOrder: item.vidOrder,
                                vidName: item.vidName,
                                vidRoles: item.vidRoles,
                                vidCatName: foundCatName,
                                vidCatOrder: foundCatOrder,
                            });
                            break;
                        } else if (!isPublic) {
                            catsWithVideos[e] = {
                                ...catsWithVideos[e],
                                hasVideos: false,
                            };
                        }
                    }
                }
            }
        }

        vids?.forEach(setVidData);

        setCatsToShow(
            catsWithVideos?.length
                ? catsWithVideos.sort((a, b) => a?.videoCategoryOrder - b?.videoCategoryOrder)
                : []
        );
        setVidsToShow(
            newVidsToShow?.length ? newVidsToShow.sort((a, b) => a?.vidOrder - b?.vidOrder) : []
        );
    }

    const opts = {
        height: '300px',
        width: '100%',
    };

    React.useEffect(() => {
        if ((vids?.length || vidCats?.length) && (userRole?.name || isPublic)) {
            initTutorialDisplay();
        }
    }, [vids, vidCats, userRole?.name, isPublic]);

    const content = (
        <>
            <div style={isPublic ? { margin: "0 2%", paddingTop: "0.5%", justifyItems: "center", boxSizing: "border-box" } : { margin: '2%', justifyItems: 'center' }}>
                <Typography
                    variant='h3'
                    textAlign="left"
                    marginBottom={isPublic ? "12px" : "20px"}
                    style={isPublic ? { color: "white" } : undefined}
                >
                    Tutorials
                </Typography>
                <Grid container spacing={3} style={{ margin: 'auto', width: 'auto' }}>
                    {catsToShow?.map((a, b) => (
                        <React.Fragment key={b}>
                            {a?.hasVideos && (
                                <Accordion
                                    className="vidAccordion"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        border: 'solid darkGray 2px',
                                        width: "100%",
                                        padding: 5,
                                        borderRadius: "5px",
                                        margin: '5px'
                                    }}
                                    expanded={expanded === b}
                                    onChange={(event, newExpanded) => handleChange(b)(event, newExpanded)}
                                >
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                        <h3 style={{ textDecoration: 'underline' }}>{a?.videoCategoryName}</h3>
                                    </AccordionSummary>
                                    <AccordionDetails style={{ justifyItems: 'center' }}>
                                        {vidsToShow?.map((y, e) => (
                                            <React.Fragment key={e}>
                                                {y?.vidCategory == a?.id && (
                                                    <Card className="youtubeCard" style={{ margin: "10px", width: "75%" }}>
                                                        <CardHeader title={y?.vidName} />
                                                        <br />
                                                        <p style={{ margin: '10px' }}>Description: {y?.vidDescription}</p>
                                                        <div className="youtubeDiv" style={{ width: '50%', justifySelf: 'center' }}>
                                                            <Youtube style={{}} videoId={y?.vidUrl} opts={opts} />
                                                        </div>
                                                    </Card>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </AccordionDetails>
                                </Accordion>
                            )}
                        </React.Fragment>
                    ))}
                </Grid>
            </div>
        </>
    );

    if (isPublic) {
        return (
            <div style={{ paddingBottom: "0.5rem", boxSizing: "border-box" }}>
                {content}
            </div>
        );
    }

    return (
        <Page title="Tutorials">
            {content}
        </Page>
    );
};

// Authenticated app route (default export for /instructions)
const Videos = () => <TutorialVideos />;

export default Videos;
export { TutorialVideos };
